import React, { useMemo } from "react";
import { RawThemeProvider, themeForTests } from "@me8eon/themes";
import { AttributeValueProvider, Renderers, SimpleAttributeValueLayout, SimpleDataLayout, SimpleDateRenderer, SimpleH1Renderer, SimpleH1WithIconAndUrlRenderer, SimpleSearchListItemRenderer, SimpleH1WithUrlRenderer, SimpleH2Renderer, SimpleH3Renderer, SimpleJsonRenderer, SimpleLabelRenderer, SimpleTextRenderer, SimpleUrlRenderer, SimpleDivRenderer } from "@me8eon/renderers";
import { MarkdownRenderer } from "@me8eon/markdown_renderers";
import { SimpleHtmlRenderer } from "@me8eon/html_renderers";

export const allRenderers: Renderers = {
    Text: SimpleTextRenderer,
    Label: SimpleLabelRenderer,
    Markdown: MarkdownRenderer,
    Html: SimpleHtmlRenderer,
    Json: SimpleJsonRenderer,
    Date: SimpleDateRenderer,
    Url: SimpleUrlRenderer,
    H1: SimpleH1Renderer,
    H1WithIconAndUrl: SimpleH1WithIconAndUrlRenderer,
    SearchListItem: SimpleSearchListItemRenderer,
    H1WithUrl: SimpleH1WithUrlRenderer,
    H2: SimpleH2Renderer,
    H3: SimpleH3Renderer,
    SimpleDiv: SimpleDivRenderer
};
type AllrenderersSimpleProviderProps = {
    children: React.ReactNode;
    renderers?: Partial<Renderers>
}

export function AllRenderersSimpleProvider({ children, renderers = {} }: AllrenderersSimpleProviderProps) {
    const actualRenders = useMemo(() => ({ ...allRenderers, renderers }), [allRenderers, renderers]);
    return <RawThemeProvider theme={themeForTests}>
        <AttributeValueProvider renderers={actualRenders} AttributeValueLayout={SimpleAttributeValueLayout} DataLayout={SimpleDataLayout}>
            {children}
        </AttributeValueProvider></RawThemeProvider>;

}
